import React, { createContext, useContext, useState, ReactNode } from "react";

interface StationContextType {
  stationId: string;
  setStationId: (value: string) => void;
  connectorId: string;
  setConnectorId: (value: string) => void;
}

const StationContext = createContext<StationContextType>({
  stationId: "",
  connectorId: "",
  setConnectorId: () => {},
  setStationId: () => {},
});

interface StationProviderProps {
  children: ReactNode;
}

export const StationProvider: React.FC<StationProviderProps> = ({
  children,
}) => {
  const [stationId, setStationId] = useState<string>("");
  const [connectorId, setConnectorId] = useState<string>("");

  return (
    <StationContext.Provider
      value={{ stationId, setStationId, connectorId, setConnectorId }}
    >
      {children}
    </StationContext.Provider>
  );
};

export const useStationContext = (): StationContextType => {
  const context = useContext(StationContext);
  return context;
};
